import { useContext, useState } from 'react'
import { Column } from 'react-table'
import TableTitle from '../../../../global/components/table/helpers/table-title/TableTitle'
import TableTopper from '../../../../global/components/table/helpers/table-topper/TableTopper'
import Table from '../../../../global/components/table/Table'
import { AuditContext } from '../../../../global/context/audit-context/AuditContext'

function AuditCancellationTable() {
  const { orderVehicle } = useContext(AuditContext)
  const [isOpen, setIsOpen] = useState(true)
  const tableState = {
    data: orderVehicle ? [orderVehicle] : [],
    isLoading: false,
  }
  const columns: Column<any>[] = [
    {
      Header: 'Reason 1',
      accessor: 'cosReason1',
    },
    {
      Header: 'Reason 2',
      accessor: 'cosReason2',
    },
    {
      Header: 'Reason 3 (Optional)',
      accessor: 'cosReason3',
    },
    {
      Header: 'Note',
      accessor: 'cosNote',
    },
    {
      Header: 'Tire Location',
      accessor: 'cosTireLocation',
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <TableTopper
        isOpen={isOpen}
        onToggleClick={() => setIsOpen(!isOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <TableTitle>Cancellation Information</TableTitle>
        </div>
      </TableTopper>
      <Table
        columns={columns}
        data={tableState.data}
        isDisplayMode={true}
        isOpen={isOpen}
      />
    </div>
  )
}

export default AuditCancellationTable
